export default __webpack_public_path__ + "static/media/expansion.e786c03a.svg";